import { Injectable } from '@angular/core';
import { environment } from '../../environments/environments'
import { HttpClient, HttpHeaders} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ServiceMangeService {

  constructor(private http: HttpClient) { }

  allServices(){
    return this.http.get(`${environment.baseUrl}/services/`)
  }

  mircoService(id:any){
    return this.http.get(`${environment.baseUrl}/services/microservices/?service_id=${id}&page=1&limit=10`)
  }

  addMicro_service(data:any){
    var formdata = new FormData();
    formdata.append("type_id", data.type_id);
    formdata.append("name", data.name);
    formdata.append("image", data.image);
    formdata.append("cost", data.cost);
    let auth_token = localStorage.getItem("acc_token")
    var myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${auth_token}`)

    var requestOptions: any = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };
    return fetch(`${environment.baseUrl}/services/microservices/`, requestOptions)

  }
  add_service(data:any){
    var formdata = new FormData();
    formdata.append("name", data.name);
    formdata.append("image", data.image);
    let auth_token = localStorage.getItem("acc_token")
    var myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${auth_token}`)

    var requestOptions: any = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };
    return fetch(`${environment.baseUrl}/services/`, requestOptions)

  }
   add_Service_Schedules(data:any){
    return this.http.post(`${environment.baseUrl}/services/booking/`,data)
   }
  edit_service(data:any){
    var formdata = new FormData();
    formdata.append("name", data.name);
    formdata.append("image", data.image);
    formdata.append("service_id", data.service_id);
    if(data.cost){
      formdata.append("cost", data.cost);
    }
    let auth_token = localStorage.getItem("acc_token")
    var myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${auth_token}`)

    var requestOptions: any = {
      method: 'PUT',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };
    return fetch(`${environment.baseUrl}/services/`, requestOptions)

  }

  serviceReuest(type:any){
    return this.http.get(`${environment.baseUrl}/services/requests/?status=${type}`)
  }

  requestUpdate(data:any){
    return this.http.put(`${environment.baseUrl}/services/update_request/`,data)

  }

  disableSerives(data:any){
    return this.http.put(`${environment.baseUrl}/services/disable/`,data)
  }

  // utilty

  retirve_all_utilties(){
    return this.http.get(`${environment.baseUrl}/utility/all`)

  }

  addUtilty(data:any){
    return this.http.post(`${environment.baseUrl}/utility/`,data)
  }

  editUtility(data:any){
    return this.http.put(`${environment.baseUrl}/utility/`,data)
  }

  addSection(data:any){
    return this.http.post(`${environment.baseUrl}/utility/section/`,data)
  }

  editSection(data:any){
    return this.http.put(`${environment.baseUrl}/utility/section/`,data)
  }

  addUtitlyImage(data:any){
    var formdata = new FormData();
    formdata.append("utility_id", data.utility_id);
    formdata.append("image", data.image);

    let auth_token = localStorage.getItem("acc_token")
    var myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${auth_token}`)

    var requestOptions: any = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };
    return fetch(`${environment.baseUrl}/images/utility/`, requestOptions)
  }

  disabledUtlity(data:any){
    return this.http.put(`${environment.baseUrl}/utility/disable/`,data)
  }


  addInvoce(data:any){
    return this.http.post(`${environment.baseUrl}/invoices/utilities/`,data)

  }
}
